import Phaser from 'phaser'
import GameUtil from '../utils/game-util'

export default class Points {
  /** @type Phaser.GameObjects.Image */
  PointsPlatform
  /** @type Phaser.GameObjects.Text */
  PointsLabel

  /**
   * @type {{
   * context: Phaser.Scene,
   * }}
   **/
  sceneContext = {}

  /**
   * @param {Phaser.Scene} context
   */
  constructor(context) {
    this.sceneContext = context
  }

  preload() {}

  create() {
    //pointsPlaftform
    let pointsPosition = GameUtil.getViewPercentage(
      { X: 90, Y: 5 },
      this.sceneContext
    )

    this.PointsPlatform = this.sceneContext.add
      .image(pointsPosition.X, pointsPosition.Y, 'plataformaPuntos')
      .setOrigin(1, 0)
    GameUtil.resetSize(this.PointsPlatform)

    if (!this.sceneContext.isMobile) {
      Phaser.Display.Align.In.BottomCenter(
        this.PointsPlatform,
        this.sceneContext.logoObj.Logo,
        5,
        110
      )
    }

    //points text
    let pointsOffsetX = this.sceneContext.isMobile ? -17 : -33
    this.PointsLabel = this.addText({
      text: this.sceneContext.data.values.POINTS,
    })
    Phaser.Display.Align.In.Center(
      this.PointsLabel,
      this.PointsPlatform,
      pointsOffsetX
    )
  }

  update() {
    this.PointsLabel.setText(this.sceneContext.data.values.POINTS)
  }

  addText({ X = 0, Y = 0, text = '', styles = {} }) {
    const ui_text_value = this.sceneContext.add
      .text(X, Y, text, {
        fontFamily: 'BwModelica-Bold',
        color: '#FFFFFF',
        fontSize: this.sceneContext.isMobile ? '17px' : '35px',
        align: 'center',
        ...styles,
      })
      .setOrigin(0, 0.5)
      .setDepth(5)

    return ui_text_value
  }
}
